export enum ProcessStatus {
    // The process is active
    active = 'active',
    // The process is cancelled, no further work can be done on it
    cancelled = 'cancelled',
    // The process is closed, no further work can be done on it
    closed = 'closed',
    // The process is completed from the perspective of the requester, work on it can continue
    completed = 'completed',
}
